/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";

export function OverviewModule(dc: IEditor): void {
	dc.get("logger").debug("Overview module enabled.");
}
